import { fetcher } from 'services/helpers/responseHandler'

const getEmail = async ({ id }) => fetcher.get(`emails`, { emailDeliveryId: id })

const emailsApi = {
  getEmail
}

export default emailsApi
